const SIGN_UP_ACTION_TYPES = {
  SIGN_UP: 'SIGN_UP',
  SIGN_UP_SPECIALITY: 'SIGN_UP_SPECIALITY',
  FETCH_CAPTCHA: 'FETCH_CAPTCHA',
};

export default SIGN_UP_ACTION_TYPES;
